import { makeStyles } from "@material-ui/styles";

const useDisplaySettingsAccordionStyles = makeStyles((theme) => ({
  formControlLabel: {
    marginLeft: 0,
    marginRight: 0,
    "& .MuiCheckbox-root": {
      paddingLeft: 0,
      marginLeft: 0,
      marginRight: theme.spacing(1),
    },
    "& .MuiFormControlLabel-label": {
      fontSize: 14,
    },
  },
}));

export default useDisplaySettingsAccordionStyles;
